/**
 * Gemini PNG menu icons (public/icons/{slug}.png)
 * SSOT: scripts/generate-menu-icons-gemini.py (bucket: itservice | workflow | tenantadmin)
 */
import { useState, type CSSProperties, type ComponentType } from 'react'
import { Sparkles } from 'lucide-react'

const BASE = `${(import.meta.env.BASE_URL || '/').replace(/\/?$/, '/')}icons`

export function menuIconUrl(slug: string): string {
  return `${BASE}/${slug}.png`
}

export function MenuPngIcon({
  slug,
  className,
  style,
  title,
}: {
  slug: string
  className?: string
  style?: CSSProperties
  title?: string
}) {
  const [failed, setFailed] = useState(false)

  if (failed) {
    return (
      <Sparkles
        className={className ?? 'h-4 w-4 shrink-0 text-muted-foreground opacity-80'}
        style={style}
        aria-hidden
      />
    )
  }

  return (
    <img
      src={menuIconUrl(slug)}
      alt=""
      title={title}
      aria-hidden
      loading="lazy"
      decoding="async"
      className={className ?? 'h-4 w-4 shrink-0 object-contain'}
      style={style}
      draggable={false}
      onError={() => setFailed(true)}
    />
  )
}

export function makeMenuIcon(slug: string, title?: string): ComponentType<{ className?: string; style?: CSSProperties }> {
  function Icon({ className, style }: { className?: string; style?: CSSProperties }) {
    return (
      <MenuPngIcon
        slug={slug}
        className={className ?? 'h-4 w-4 shrink-0 object-contain'}
        style={style}
        title={title}
      />
    )
  }
  Icon.displayName = `MenuIcon(${slug})`
  return Icon
}
